import vueVimeoPlayer from 'vue-vimeo-player'
//import SVG from 'svgjs'


import Vue from "vue"
import App from "./App.vue"
import TDM from "./TDM.json"

Vue.config.productionTip = false;
//Vue.use(vueVimeoPlayer);

Vue.mixin({
  data: function() {
    return {
      get baseurl() {
        return '/';
        //return '/elf/apps/intergenerational-map/INTERGENERATIONALMAPEN/';
      },
      getTDM(camp, path, item) {
        let path_slug = 'family';

        switch (path) {
          case 2: path_slug = 'business'; break;
          case 3: path_slug = 'ownership'; break;
        }

        return TDM[camp][path_slug][item];
      },
      getTDMByCamp(camp, path) {
        let path_slug = 'family';

        switch (path) {
          case 2: path_slug = 'business'; break;
          case 3: path_slug = 'ownership'; break;
        }

        if (path) {
          return TDM[camp][path_slug];
        } 

        return TDM[camp];
      },
      getTDMSize(camp, path) {
        let path_slug = 'family';

        switch (path) {
          case 2: path_slug = 'business'; break;
          case 3: path_slug = 'ownership'; break;
        }

        if (TDM[camp]) {
          return TDM[camp][path_slug];
        }

        return [];
      }
    };
  },
});


new Vue({
  render: (h) => h(App)
}).$mount("#app");
